import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useEffect } from "react";

interface DonateModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DonateModal = ({ isOpen, onClose }: DonateModalProps) => {
  // Preload Donately script when component mounts
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.donately.com/core/6.0/donately.min.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  // Initialize Donately form when modal opens
  useEffect(() => {
    if (!isOpen) return;

    const dntlyReady = (name: string, callback: (lib: any) => void) => {
      window.setTimeout(() => {
        if ((window as any)[name]) {
          callback((window as any)[name]);
        } else {
          dntlyReady(name, callback);
        }
      }, 10);
    };

    dntlyReady("Donately", (Donately) => {
      const configOptions = {
        selector: '#dntly-donation-form',
        options: {
				'donately-id':'act_6ad45756ed57',
				'stripe-publishable-key':'pk_live_51Rw6MiAZslzr1nRoyCtU8OZ6q58aDjjCjj85m9nR3gollgJHfIzZvhy6dOTWYWcAXVohZISBksraEVpbakuOvS6v00T2Uwvh0E',
				'donately-form-id':'frm_adc72f0ccaf7',
				'donately-presets':'100,250,500,1000,5000',
				'donately-amount':"{\"default\":\"100\"}",
				'donately-currency':'USD',
				'donately-payment-options':'cc',
				'donately-recurring-frequency':"[\"false\"]",
				'donately-donor-pays-fees':"{\"cc\":{\"processor_percent\":0.029,\"processor_fixed\":0.3,\"processor_cap\":0,\"dntly_percent\":0.02,\"complex_calc\":true}}",
				'donately-comment':true,
				'donately-anonymous':true,
				'donately-confirmation-config':"{\"thank_you_message_subheader\":\"<br/>\\nA receipt has been sent to {{email}}.\\n<br/><br/>\\nDonately will reflect your donation in the total funding progress in a few minutes.\",\"social_share_url\":\"https://FixTheFormula.org\",\"display_social_icons\":true}",
				'donately-theme':'modern',
				'donately-custom-theme':"{\"-PrimaryColor\":\"#7aa3fa\",\"-ButtonBackgroundColor\":\"#7aa3fa\",\"-SubmitButtonBackgroundColor\":\"#7aa3fa\",\"-PopupButtonBackgroundColor\":\"#7aa3fa\"}",
				'donately-campaign-id':'cmp_64e6184d0aca',
				'donately-i18n-locale':'en_US',
				'donately-form-navigation':"{\"steps\":[[\"presets\",\"amount\",\"donorpaysfees\",\"paymentmethods\",\"anonymous\",\"namegroup\",\"email\",\"comment\",\"submit\",\"recurringgroup\"]]}",},
        afterFormLoad: function() {},
        afterNavigateHook: function(stepNumber: any) {},
        onSuccess: function(donation: any){},
        onError: function(error: any){}
      };
      Donately.init(configOptions);
    });

    return () => {
      // Clear the donation form when modal closes
      const formElement = document.getElementById('dntly-donation-form');
      if (formElement) {
        formElement.innerHTML = '';
      }
    };
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl mx-auto bg-card border-border rounded-lg p-0 overflow-hidden max-h-[95vh] h-[90vh] flex flex-col">
        <div className="pt-8 px-8 pb-[10px] flex-shrink-0">
          <DialogHeader className="text-center">
            <DialogTitle className="text-2xl font-medium text-foreground mb-2 tracking-wide">
              Support Our Mission 💝
            </DialogTitle>
            <p className="text-muted-foreground">
              Help us test baby formula for heavy metals, toxins, macronutrients, and contaminants
            </p>
          </DialogHeader>
        </div>

        <div className="flex-1 overflow-auto px-8 pb-8 min-h-0">
          <div id="dntly-donation-form"></div>
        </div>
      </DialogContent>
    </Dialog>
  );
};